// extracted by mini-css-extract-plugin
module.exports = {"container":"video_container__2cLFX","video":"video_video__3wcM1","videoPlayer":"video_videoPlayer__3TA9q"};